import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

export async function listCommissions({
                                          statusFilter,
                                          beneficiaryId,
                                          sourceUserId,
                                          limit,
                                      } = {}) {
    const params = new URLSearchParams();
    if (statusFilter) params.set('status_filter', statusFilter);
    if (beneficiaryId) params.set('beneficiary_id', beneficiaryId);
    if (sourceUserId) params.set('source_user_id', sourceUserId);
    if (limit) params.set('limit', String(limit));

    const url = `/super_admin/referral/commissions${
        params.toString() ? `?${params}` : ''
    }`;

    const { data, error } = await client.GET(url);
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت پورسانت‌ها.'));
    }
    return data || [];
}

export async function approveCommission(id) {
    const { data, error } = await client.POST(
        `/super_admin/referral/commissions/${id}/approve`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در تأیید پورسانت.'));
    }
    return data;
}

export async function cancelCommission(id) {
    const { data, error } = await client.POST(
        `/super_admin/referral/commissions/${id}/cancel`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در لغو پورسانت.'));
    }
    return data;
}

export async function restoreCommission(id) {
    const { data, error } = await client.POST(
        `/super_admin/referral/commissions/${id}/restore`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در بازگردانی پورسانت.'));
    }
    return data;
}

export async function approveAllPending() {
    const { data, error } = await client.POST(
        `/super_admin/referral/commissions/approve-all-pending`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در تأیید گروهی.'));
    }
    return data;
}

export async function getUserReferralSummary(userId) {
    const { data, error } = await client.GET(
        `/super_admin/referral/users/${userId}/summary`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت اطلاعات کاربر.'));
    }
    return data;
}